import React, { useState } from 'react';
import '../styles/Navbar.css';
import logoImg from "../img/Stud Labs Full.png"
import * as Brands from "@fortawesome/free-brands-svg-icons"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);


  return (
    <>
      <div class="banner"><div class="container"><a href="#">MINTING - MAY/JUNE 2022</a></div></div>
      <nav className='navbar'>
        <div className='navbar-container'>
        <a href="#top" className='navbar-logo' onClick={closeMobileMenu}>
            <img src={logoImg} alt='logoImg'/>
          </a>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
              <li className='nav-item'>
                <a href="#about" onClick={closeMobileMenu}>About</a>
              </li>
              <li className='nav-item'>
                <a href="#collections" onClick={closeMobileMenu}>Collections</a>
              </li>
              <li className='nav-item'>
                <a href="#creation" onClick={closeMobileMenu}>Creation Process</a>
              </li>
              <li className='nav-item'>
                <a href="#sponsors" onClick={closeMobileMenu}>Sponsors</a>
              </li>
              <li className='nav-item socials'>
                <a href="https://twitter.com/StudLabs" target="_blank" onClick={closeMobileMenu}><FontAwesomeIcon icon={Brands.faTwitter}/></a>
              </li>
              <li className='nav-item socials'>
                <a href="https://discord.gg/pKXmqqUYtR" target="_blank" onClick={closeMobileMenu}><FontAwesomeIcon icon={Brands.faDiscord}/></a>
              </li>
              <li className='nav-item socials'>
                <a href="#" target="_blank" onClick={closeMobileMenu}><svg class="icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" aria-hidden="true" focusable="false"><path d="M60.713 135.684a19.825 19.825 0 00-6.453-16.728L6.453 61.366v-8.603H154.89L269.625 304.39 370.497 52.763 512 52.764v8.602l-40.874 39.189a11.944 11.944 0 00-4.541 11.472v287.947a11.942 11.942 0 004.541 11.471l39.917 39.19v8.602H310.261v-8.602l41.35-40.147c4.065-4.061 4.065-5.257 4.065-11.468V166.271L240.703 458.28h-15.536L91.308 166.271V361.98a27.006 27.006 0 007.41 22.462l53.784 65.235v8.603H0v-8.603l53.784-65.235a26.05 26.05 0 006.929-22.462V135.684z" fill-rule="nonzero"></path></svg></a>
              </li>
            </ul>
         
            <div className='menu-icon' onClick={handleClick}>
            <FontAwesomeIcon icon={faBars} />
            
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
